import React, { Component } from "react";
import PropTypes from "prop-types";

class TextInput extends Component {
  constructor(props) {
    super(props);
    this.textRef = React.createRef();
    this.state = {
      editMode: true,
      value: props.value || ""
    };
  }

  componentDidMount = () => {
    if (this.props.value) {
      this.setState({ editMode: this.props.value.length < 1 });
    }
  };

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value) {
      this.setState({ value: this.props.value }); // eslint-disable-line react/no-did-update-set-state
    }
  }

  onChange = event => {
    this.setState({
      value: event.target.value
    });
    if (this.props.onChange) {
      this.props.onChange();
    }
  };

  handleEnterKey = e => {
    e.stopPropagation();
    if (e.key === "Enter") {
      e.target.blur();
      if (this.props.onSave) {
        this.props.onSave();
      }
    }
  };

  render() {
    const { inputRef, value, isTextArea, ...rest } = this.props;

    return isTextArea ? (
      <textarea
        ref={inputRef}
        autoFocus
        className={
          this.state.editMode ? "textInput" : "textInput textInput--with-value"
        }
        onBlur={() => {
          if (value) {
            this.setState({ editMode: value.length < 1 });
          }
        }}
        onClick={() => {
          this.setState({ editMode: true });
        }}
        onKeyDown={this.handleEnterKey}
        onKeyPress={this.handleEnterKey}
        type="text"
        onChange={this.onChange}
        value={this.state.value}
        {...rest}
      />
    ) : (
      <input
        ref={inputRef}
        autoFocus
        className={
          this.state.editMode ? "textInput" : "textInput textInput--with-value"
        }
        onBlur={() => {
          if (value) {
            this.setState({ editMode: value.length < 1 });
          }
        }}
        onClick={() => {
          this.setState({ editMode: true });
        }}
        onKeyDown={this.handleEnterKey}
        onKeyPress={this.handleEnterKey}
        type="text"
        onChange={this.onChange}
        value={this.state.value}
        {...rest}
      />
    );
  }
}

TextInput.propTypes = {
  /** Default value for input text  */
  inputRef: PropTypes.func,
  isTextArea:PropTypes.bool,
  value: PropTypes.string,
};
TextInput.defaultProps = {
  inputRef: () => {},
  isTextArea: false,
  value: "",
};

export default TextInput;
